import './DailyQuiz.scss';

import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';

import { canPerformAction } from '../../utilities/permissionUtils';
import DailyQuizTable from './components/DailyQuizTable';

function DailyQuiz({
  allDailyQuiz,
  getAllDailyQuizForToday,
  generateDailyQuizForToday,
  permissions = [],
}) {
  const [noDailyQuizList, setNoDailyQuizList] = useState([]);
  const [dailyQuizList, setDailyQuizList] = useState([]);

  useEffect(() => {
    getAllDailyQuizForToday();
  }, []);

  useEffect(() => {
    setNoDailyQuizList(
      allDailyQuiz.filter(
        (dailyQuiz) =>
          !dailyQuiz.questions || dailyQuiz.questions?.length === 0,
      ),
    );

    setDailyQuizList(
      allDailyQuiz.filter(
        (dailyQuiz) => dailyQuiz.questions && dailyQuiz.questions?.length > 0,
      ),
    );
  }, [allDailyQuiz]);

  const canGenerate = canPerformAction(
    'Settings.DailyQuiz.Generate',
    permissions,
  );

  return (
    <Col className="daily-quiz-container">
      {canGenerate && (
        <div
          className="generate-daily-button"
          onClick={() => {
            generateDailyQuizForToday();
          }}
        >
          Generate Daily Quiz for today
        </div>
      )}

      <Row className="rates-daily-quiz-container">
        {/* Rates without daily quiz */}
        <div className="rates-daily-quiz">
          <p className="title-text">
            AFSC exams <span className="text-red">without</span> daily quiz for
            today:
          </p>
          {dailyQuizList.length === 0 && (
            <p className="text-red">No AFSC Exam has a daily quiz for today!</p>
          )}
          {noDailyQuizList.length !== 0 ? (
            <DailyQuizTable dailyList={noDailyQuizList} />
          ) : (
            '-'
          )}
        </div>

        {/* Rates with daily quiz */}
        <div className="rates-daily-quiz">
          <p className="title-text">AFSC exams with daily quiz for today:</p>
          {noDailyQuizList.length === 0 && (
            <p className="text-green">
              All AFSC Exams have a Daily Quiz for today!
            </p>
          )}
          {dailyQuizList.length !== 0 ? (
            <DailyQuizTable dailyList={dailyQuizList} />
          ) : (
            '-'
          )}
        </div>
      </Row>
    </Col>
  );
}

export default DailyQuiz;
